export default "__VITE_ASSET__BED2$2bM__"